import { saveBlobFile } from './appUtils';
import { downloadAWSDoc } from '../policies/PolicyService';
import { manageAPIError } from './error.utils';
import { useNotifications } from '../_lib/notifications/useNotifications';

export interface DocumentDownloadParams {
  asyncDownload?: () => Promise<{ data: string }>;
  url?: string;
  blobFileParams: {
    docName: string;
    docType?: string;
  };
  onError?: () => void;
}

export const useDocumentDownload = () => {
  const notifications = useNotifications();

  return async ({
    asyncDownload,
    url,
    blobFileParams,
    onError,
  }: DocumentDownloadParams) => {
    const downloadUrl =
      url ?? (await asyncDownload?.().then(({ data: url }) => url));

    if (downloadUrl) {
      notifications.show({
        title: 'Download started, file will be available shortly',
        type: 'info',
        position: 'top-right',
      });

      return downloadAWSDoc(downloadUrl)
        .then((response: any) =>
          saveBlobFile(
            response,
            blobFileParams.docName,
            blobFileParams.docType ?? '.pdf'
          )
        )
        .catch((error: any) => {
          if (onError) {
            onError();
            return;
          }
          notifications.show({
            title: manageAPIError(error),
            type: 'error',
          });
        });
    }
  };
};
